import {
  Box,
  Breadcrumbs,
  Container,
  Grid2 as Grid,
  Link,
  Typography,
} from "@mui/material";
import { Link as NavLink } from "react-router-dom";
import Images from "../../assets/js/Images";

function TopBannerA({
  bannerImg,
  currentPage,
  heading,
  menus,
  overlay = true,
}) {
  return (
    <Box
      component="section"
      sx={{
        bgcolor: "dark.main",
        backgroundSize: "cover",
        backgroundPosition: { xs: "top left", md: "center" },
        backgroundImage: `url("${bannerImg || Images?.oneOnOne}")`,
      }}
    >
      <Box
        sx={{
          py: { xs: 12, lg: 15 },
          bgcolor: overlay ? "transparent" : "transparent",
        }}
      >
        <Container maxWidth={false} fixed>
          <Grid container spacing={2} alignItems="center">
            <Grid size={{ xs: 12, md: "grow" }}>
              <Typography
                color="white"
                component="h2"
                variant="topBannerTitle"
                textAlign={{ xs: "center", md: "start" }}
              >
                {heading}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: "auto" }}>
              <Breadcrumbs
                sx={{
                  color: "white",
                  textAlign: { xs: "center", md: "start" },
                  ".MuiBreadcrumbs-ol": {
                    justifyContent: { xs: "center", md: "start" },
                  },
                }}
                component="div"
                maxItems={4}
              >
                <Link
                  to="/"
                  color="inherit"
                  underline="hover"
                  component={NavLink}
                >
                  Home
                </Link>
                {menus?.map((menu, i) => (
                  <Link
                    key={i}
                    to={menu?.path}
                    color="inherit"
                    underline="hover"
                    component={NavLink}
                  >
                    {menu?.name}
                  </Link>
                ))}
                <Typography component="span" sx={{ color: "white" }}>
                  {currentPage}
                </Typography>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}

export default TopBannerA;
